import { FormattedMessage } from 'react-intl';
import { Outlet } from 'react-router-dom';

import Tab from 'src/registry/components/navigation/Tab';
import TabRow from 'src/registry/components/navigation/TabRow';
import { moneyAccountsMessages } from 'src/features/moneyAccounts/utils/messages';
import { bankAccountMessages } from 'src/features/billingEntityBankAccounts/utils/messages';
import useHasPermissions from 'src/utils/useHasPermissions';
import { PERMISSION } from 'src/features/auth/types';

/** Tab row for the billing entity dashboard. The panels are child routes declared in HomeRoutes. */
const BillingEntityDashboardTables = () => {
    const permissionAccessMoneyAccounts = useHasPermissions([PERMISSION.ACCESS_MONEY_ACCOUNTS]);

    return (
        <div className="grid flex-3 grid-cols-1 pr-8">
            <TabRow>
                {permissionAccessMoneyAccounts && (
                    <Tab to="money-accounts" preventScrollReset>
                        <FormattedMessage {...moneyAccountsMessages.moneyAccounts} />
                    </Tab>
                )}
                <Tab to="bank-accounts" preventScrollReset>
                    <FormattedMessage {...bankAccountMessages.bankAccounts} />
                </Tab>
            </TabRow>
            <div className="mt-4">
                <Outlet />
            </div>
        </div>
    );
};

export default BillingEntityDashboardTables;
